import { makeStyles, Theme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import LiquidFormHelpText from '@src/components/LiquidFormHelpText'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import { Field, FormikProps } from 'formik'
import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useDebounce } from 'react-use'
import messages from '../../../messages'
import { ConfigContext } from '../Genomics'
import { CrisprItemFormValues } from './ViewCrisprItem'
import { GenomicsProperties } from '../enum'
import { useCustomCrisprTotalValidationMutation } from '@src/mutations/ConfiguratorTubesMutation.generated'
import { ConfiguratorValues } from '@src/routes/Configurators/utils/constants'
import { ConfiguratorProductInput } from '@src/types/graphql-types'

const useStyles = makeStyles((theme: Theme) => {
  return {
    sequenceHelpText: {
      textAlign: 'right',
      fontSize: theme.typography.pxToRem(9),
      display: 'flex-end',
    },
    helpTextGroup: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  }
})
interface SequenceFieldProps {
  formikBag: FormikProps<CrisprItemFormValues>
  selectedItemIndex: number
  setIsSave: React.Dispatch<React.SetStateAction<boolean>>
  isSequenceEntryPage: boolean
  initialSequence?: Maybe<string> | undefined
  productDetails: ConfiguratorProductInput
  setSequenceValidation: React.Dispatch<React.SetStateAction<string[]>>
  sequenceValidation: string[]
}

const SequenceField: React.FC<SequenceFieldProps> = ({
  formikBag,
  selectedItemIndex,
  setIsSave,
  isSequenceEntryPage,
  initialSequence,
  productDetails,
  setSequenceValidation,
  sequenceValidation,
}) => {
  const classes = useStyles()
  const { state, dispatch } = React.useContext(ConfigContext)
  const { sessionData } = state
  const [customCrisprTotalValidationMutation] =
    useCustomCrisprTotalValidationMutation()
  const [sequence, setSequence] = useState<string | null | undefined>(
    initialSequence
  )
  const [baseCount, setBaseCount] = useState<number | string>(
    initialSequence?.split(' ').join('').length || '--'
  )

  const countText = (value: string) => {
    const val = value
      .replace(/[\u007F-\u00A0]/g, '')
      .replace(/\\f/g, '')
      .replace(/%/g, '')
      .toUpperCase()
      .replace('U', 'T')
    setSequence(val)
    sessionData[0].listSubModels[selectedItemIndex].sequence = val
    sessionData[0].listSubModels[selectedItemIndex].baseCount = val
      .split(' ')
      .join('').length
    setBaseCount(val.split(' ').join('').length)
    //updating pageNo = 0 to disable side bar for other pages
    //when selecting view item pop-up  from Sequence Entry page
    if (state.stepNo !== 0 && isSequenceEntryPage) {
      sessionData[0].pageNo = 0
      dispatch({ type: 'SET_STEP_NO', data: 0 })
    }
    return val
  }

  const callSeqValidationAPI = async () => {
    setIsSave(false)
    const response = await customCrisprTotalValidationMutation({
      variables: { input: sessionData, productInput: productDetails },
    })
    let validationResponse
    if (response?.data?.customCrisprTotalValidation)
      validationResponse = response?.data?.customCrisprTotalValidation[0]

    if (validationResponse && !validationResponse.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      const listSubModels = validationResponse?.listSubModels
      if (listSubModels) {
        const validationError =
          listSubModels[selectedItemIndex]?.listSubModelErrors
        setSequenceValidation([])

        dispatch({
          type: 'UPDATE_VIEW_ITEM_ERRORS',
          data: [],
        })
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: '',
        })
        const error: any[] = []
        if (validationError) {
          validationError.forEach((item) => {
            if (item?.key === GenomicsProperties.SequenceKey) {
              setBaseCount('--')
              error.push(item?.value)
            }
          })
        }

        formikBag.setFieldError(
          'sequence',
          error.length > 0 ? 'error' : undefined
        )

        setSequenceValidation(error)
      }
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
    }
  }

  useDebounce(
    () => {
      callSeqValidationAPI()
    },
    GenomicsProperties.SEQUENCE_API_TIME,
    [sequence]
  )

  return (
    <Grid item xs={12}>
      <Field
        label={<FormattedMessage {...messages.CONF_CUSTOM_CRISPR_SEQUENCE} />}
        name="sequence"
        component={LiquidInputAdapter}
        filled
        required
        autoComplete="off"
        onChange={async (e) => {
          formikBag.setFieldTouched('sequence', true)
          const value = countText(e.target.value)
          formikBag.setFieldValue('sequence', value)
        }}
        displayError={false}
        error={sequenceValidation.length > 0}
        fullWidth
      />
      <div className={classes.helpTextGroup}>
        <div>
          {sequenceValidation.length > 0 &&
            sequenceValidation.map((sequenceError) => (
              <div key={sequenceError}>
                <LiquidFormHelpText error>{sequenceError}</LiquidFormHelpText>
              </div>
            ))}
        </div>
        <div className={classes.sequenceHelpText}>
          <FormattedMessage {...messages.CONF_BASE_COUNT} />
          {sequenceValidation.length === 0 ? baseCount : ' --'}
        </div>
      </div>
    </Grid>
  )
}
export default SequenceField
